import type { CommentBodyLinkProps } from '@liveblocks/react-ui/primitives'
import { Comment } from '@liveblocks/react-ui/primitives'

export const CommentLink = ({ href, children }: CommentBodyLinkProps) => (
  <Comment.Link href={href} className='text-main-foreground-accent underline'>
    {children}
  </Comment.Link>
)
